import React from 'react';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import { OrderHistorySkinnable } from './OrderHistorySkinnable';
import { OrderHistoryProps } from './OrderHistory.types';
import { adaptOrderHistoryProps } from './OrderHistory.adapter';
import { COMPONENT_TYPES } from '../../../constants';
import './OrderHistory.css';

/**
 * 주문 내역 컴포넌트 (스킨 시스템 사용)
 */
const OrderHistoryComponent: React.FC<OrderHistoryProps> = (props) => {
  // 어댑터를 통해 props 변환
  const adaptedProps = adaptOrderHistoryProps(props);
  
  // ComponentData 구성
  const componentData = {
    id: adaptedProps.id || `${COMPONENT_TYPES.ORDER_HISTORY}-${Date.now()}`,
    type: COMPONENT_TYPES.ORDER_HISTORY,
    componentProps: adaptedProps.componentProps || {},
    props: adaptedProps,
    theme: adaptedProps.theme || {},
    externalSkin: adaptedProps.externalSkin,
    utils: {
      navigate: (path: string) => {
        if (typeof window !== 'undefined') {
          window.location.href = path;
        }
      }
    }
  };
  
  // 렌더 모드 결정
  const mode = adaptedProps.isEditor ? 'editor' : 
               adaptedProps.isPreview ? 'preview' : 'production';
  
  // 에디터 props (필요한 경우)
  const editorProps = adaptedProps.isEditor ? {
    isSelected: adaptedProps.isSelected || false,
    onSelect: adaptedProps.onSelect,
    onEdit: adaptedProps.onEdit,
    onDelete: adaptedProps.onDelete
  } : undefined;
  
  // 선택된 스킨 결정
  const selectedSkin = adaptedProps.skin || 
                      adaptedProps.componentProps?.skin || 
                      'basic';
  
  return (
    <ComponentSkinWrapper
      component={OrderHistorySkinnable}
      componentData={componentData}
      skinId={selectedSkin}
      mode={mode}
      editorProps={editorProps}
    />
  );
};

export default OrderHistoryComponent;